import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectDbasListItems } from "../../../../../../redux/dbas/selector";
import { dbas } from "../../../../../../redux/dbas/action";
import PageLoader from "../../../../../../components/PageLoader";
import Table from "../../../../../../common/components/table-manager/v1.1/table";



const DBARegistries = ({selectedDbnp}: any) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10); 
  const dbasItems = useSelector(selectDbasListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', filter: true,
        filterType: 'text' },
        { field: 'Types', headerName: 'Type',  valueFormatter: getTypeName ,filterType: 'text' },
        { field: 'TotalNoOfGateways', headerName: 'Total No Of Gateways', searchField: 'TotalNoOfGateways', filter: true,
          filterType: 'text',callback: handleGateway },
        { field: 'Description', headerName: 'Description',  filterType: 'text' },
    ]);
  }
  const handleGateway = async () => {
    navigate(`/management/dbn-cloud/gateways`)
}
  const getTypeName = (data: any) => {
    if (Array.isArray(data)) {
        return data.join('\n'); 
    }
    return data;
};
  const fetchDBASist = () => {
    dispatch(dbas.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas/list`,
      entity: 'dbas',
      jsonData: {
        "Filters": [
              {
              "FieldName": "DBNPId",
              "FilterOperatorId": 1,
              "FieldValue": selectedDbnp?.Id,
              "FieldType": "number"
              },
            ],
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  useEffect(() => {
    createColumnDefs()
    fetchDBASist()
  }, [pageData,pageSize])


  const handleNewDBATypeToExistingDBA = (data: any) => {
    navigate(`/management/dbn-cloud/dba-type-mappngs/${data?.Id}`)
  }


  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    }
  ];

  const handleReloadData = () => {
    fetchDBASist();
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    dispatch(dbas.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/dbn/dbas/list`,
      entity: 'dbas',
      jsonData: {
        "Filters": [
            {
            "FieldName": "DBNPId",
            "FilterOperatorId": 1,
            "FieldValue": selectedDbnp?.Id,
            "FieldType": "number"
            },
          ],
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  const handleSelect = (item: any, checked: any) => {
    console.log("Item", checked, item)
  }

  const handleSelectAll = (items: any[], checked: any) => {
    console.log("Items count", checked, items?.length)
    console.log('items', items)
  }

  return (
    <>
      {dbasItems?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={dbasItems?.result?.items} setPageData={setPageData} setPageSize={setPageSize}
        enableFilter={true} onSearch={handleSearch}  onSelectAll={handleSelectAll}
          paginationData={dbasItems?.result?.pagination} 
          additionButtons={additionButtons} headingName="DBAS" checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Id',
        }} />
      }
    </>
  );
};

export default DBARegistries;


